import { FormattedMessage } from 'react-intl';
import React from 'react';

export const DisclaimerPage = () => (
  <div>
    <p style={{ color: 'red' }}>
      <FormattedMessage id="journeyBuilder.warningArticleInRed" />
    </p>
    <p>
      <FormattedMessage id="journeyBuilder.warningArticle" />
    </p>
  </div>
);

DisclaimerPage.displayName = 'DisclaimerPage';

export default DisclaimerPage;



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/components/DisclaimerPage/index.js